import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import gForm from "@/components/g-form/g-form";
import gDataTable from "@/components/g-data-table/g-data-table";
import ChecklistAmostraLoteViewModel from "@/shared/view-models/ChecklistAmostraLoteViewModel";

const name = 'ChecklistAmostraLotePDF'
export default {
  name,
  setup() {
    return {
    }
  },

  components: {
    'g-button': gButton,
    'g-card': gCard,
    'g-date-input': gDateInput,
    'g-form': gForm,
    'g-data-table': gDataTable,
  },

  props: {
    checkListAmostraSelecionada: {
        type: String,
        default: ''
      },
   },


  mounted () {
    this.GetChecklistAmostraLote()
   },

  updated () {     
    this.GetChecklistAmostraLote()
  },

  data () {
    return {
        pt1: true,
        ChecklistArray: [],
        objFiltros: new ChecklistAmostraLoteViewModel(),
        ClienteArray: [],
        UnidadeArray: [],
        checkListId: null,
       
     }
  },

  methods: {

    GetChecklistAmostraLote() {

      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `ChecklistAmostraLote/GetChecklistAmostraLoteById/${this.checkListAmostraSelecionada}`,
      })
        .then(response => {
          this.ChecklistArray = response.data.data
          this.executaTermino()
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },
    executaTermino(){
      this.$emit('termino')
    },  
  

  computed: { },

    }
};